import log from "loglevel";
import SETTINGS from "../../settings";

const calculateContours = (terrain1) => {
  const terrain = terrain1;
  const contourInterval = Math.floor(
    (terrain.heightLimits.max - terrain.heightLimits.min) / 100 + 1
  );
  const numberOfContours = Math.ceil(
    Math.abs(terrain.heightLimits.max - terrain.heightLimits.min) /
      contourInterval
  );
  const lowestContour =
    terrain.heightLimits.min -
    (terrain.heightLimits.min % contourInterval) +
    contourInterval;
  // const contourInterval = 10;
  const size = terrain.size;
  log.info("Calculating Contours");
  log.info("Contour Intervals: " + contourInterval);
  let lines = [];
  let newPoints = [];
  let pairsOfVertices = [];
  let linesByGrid = [];
  let allContourLines = [];
  for (let i = 0; i < terrain.noOfVertices.x - 1; i++) {
    for (let j = 0; j < terrain.noOfVertices.y - 1; j++) {
      const pos = { x: i, y: j };
      let corners = [
        { x: 0, y: 0, z: terrain.altitudes[pos.x][pos.y] },
        { x: 0, y: 1, z: terrain.altitudes[pos.x][pos.y + 1] },
        { x: 1, y: 1, z: terrain.altitudes[pos.x + 1][pos.y + 1] },
        { x: 0, y: 1, z: terrain.altitudes[pos.x + 1][pos.y] },
      ];
      let gridLowestHeight = Math.min(
        ...corners.map((vert, i) => {
          return vert.z;
        })
      );
      let gridHighestHeight = Math.max(
        ...corners.map((vert, i) => {
          return vert.z;
        })
      );
      var indexOfLowestCorner = corners.findIndex((obj) => {
        return obj.z === gridLowestHeight;
      });
      let allEdgesVerts = [];

      for (let k = 0; k < 4; k++) {
        let edge = [corners[k], corners[(k + 1) % 4]];
        let min = Math.min(edge[0].z, edge[1].z);
        let max = Math.max(edge[0].z, edge[1].z);
        let heightRange = max - min;
        let verts = [];
        for (
          let c = min - (min % contourInterval) + contourInterval;
          c < max + 1;
          c = c + contourInterval
        ) {
          let inc = Math.abs((c - min) / heightRange);
          if (k == 0) {
            if (edge[0].z > edge[1].z) {
              allEdgesVerts.push({
                x: pos.x + corners[k].x,
                y: pos.y + 1 - corners[k].y - inc,
                z: c,
              });
            } else {
              allEdgesVerts.push({
                x: pos.x + corners[k].x,
                y: pos.y + corners[k].y + inc,
                z: c,
              });
            }
          } else if (k == 1) {
            if (edge[0].z < edge[1].z) {
              allEdgesVerts.push({
                x: pos.x + corners[k].x + inc,
                y: pos.y + corners[k].y,
                z: c,
              });
            } else {
              allEdgesVerts.push({
                x: pos.x + corners[k].x + 1 - inc,
                y: pos.y + corners[k].y,
                z: c,
              });
            }
          } else if (k == 2) {
            if (edge[0].z > edge[1].z) {
              allEdgesVerts.push({
                x: pos.x + corners[k].x,
                y: pos.y + corners[k].y - 1 + inc,
                z: c,
              });
            } else {
              allEdgesVerts.push({
                x: pos.x + corners[k].x,
                y: pos.y + corners[k].y - inc,
                z: c,
              });
            }
          } else if (k == 3) {
            if (edge[0].z < edge[1].z) {
              allEdgesVerts.push({
                x: pos.x - corners[k].x + 1 - inc,
                y: pos.y,
                z: c,
              });
            } else {
              allEdgesVerts.push({
                x: pos.x + corners[k].x + inc,
                y: pos.y,
                z: c,
              });
            }
          }
        }
      }
      for (
        let c =
          gridLowestHeight -
          (gridLowestHeight % contourInterval) +
          contourInterval;
        c < gridHighestHeight + 1;
        c += contourInterval
      ) {
        let verts = [...allEdgesVerts];
        var indexOfA = verts.findIndex((obj) => {
          return obj.z === c;
        });
        let a = verts[indexOfA];
        verts.reverse();
        var indexOfB = verts.findIndex((obj) => {
          return obj.z === c;
        });
        let b = verts[indexOfB];
        linesByGrid.push([a, b]);
      }
    }
  }

  linesByGrid.sort(function (a, b) {
    return a[0].z - b[0].z;
  });
  let linesByC = [];

  for (let c = 0; c < numberOfContours; c++) {
    linesByC[c] = [];
  }
  for (let i = 0; i < linesByGrid.length; i++) {
    let c = (linesByGrid[i][0].z - lowestContour) / contourInterval;
    linesByC[c].push(linesByGrid[i]);
  }

  // log.info(linesByC);
  let isoLines = [];
  for (let i = 0; i < linesByC.length; i++) {
    for (let j = 0; j < linesByC[i].length; j++) {
      isoLines.push(new IsoLine(linesByC[i][j]));
    }
  }
  // log.info(isoLines);
  return isoLines;
};

class IsoLine {
  constructor(line) {
    this.begin = { x: line[0].x, y: line[0].y };
    this.end = { x: line[1].x, y: line[1].y };
    this.ordered = [this.begin, this.end];
    this.elevation = line[0].z;
  }
  // addLine(line) {
  //   if (line[0].z == this.elevation) {
  //     if (sameVertex(this.begin, line[0])) {
  //       this.ordered.splice(0, 0, line[1]);
  //       this.begin = line[1];
  //       return true;
  //     } else if (sameVertex(this.begin, line[1])) {
  //       this.ordered.splice(0, 0, line[0]);
  //       this.begin = line[0];
  //       return true;
  //     } else if (sameVertex(this.end, line[0])) {
  //       this.ordered.push(line[1]);
  //       this.end = line[1];
  //       return true;
  //     } else if (sameVertex(this.end, line[1])) {
  //       this.ordered.push(line[0]);
  //       this.end = line[0];
  //       return true;
  //     } else {
  //       return false;
  //     }
  //   }
  //   return false;
  // }
}

const sameVertex = (point1, point2) => {
  return point1.x == point2.x && point1.y == point2.y;
};

const ContourLines = (props) => {
  const terrain = props.terrain;
  const noOfVertices = terrain.noOfVertices;
  const size = terrain.boundBox.size;
  const min = terrain.heightLimits.min;
  const scale = SETTINGS.TERRAIN.SCALE;

  let isoLines = calculateContours(terrain);
  for (let i = 0; i < isoLines.length; i++) {
    for (let j = 0; j < isoLines[i].ordered.length; j++) {
      isoLines[i].ordered[j].x =
        ((isoLines[i].ordered[j].x / (noOfVertices.x - 1)) * size.x -
          size.x / 2) /
        scale;
      isoLines[i].ordered[j].y =
        ((isoLines[i].ordered[j].y / (noOfVertices.y - 1)) * size.y -
          size.y / 2) /
        scale;
      isoLines[i].ordered[j].z = -(isoLines[i].elevation - min) / scale;
    }
  }

  return (
    <group rotation={[Math.PI / 2, 0, 0]}>
      {isoLines.map((isoLine, i) => {
        return (
          <line key={i}>
            <geometry
              attach="geometry"
              vertices={isoLine.ordered}
              onUpdate={(self) => (self.verticesNeedUpdate = true)}
            />
            <lineBasicMaterial attach="material" color={0x997700} />
          </line>
        );
      })}
    </group>
  );
};
export default React.memo(ContourLines);
